import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  IconButton,
  LinearProgress,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ModuleLayout from '../components/ModuleLayout';

function ModulePage() {
  const { moduleId } = useParams();
  const navigate = useNavigate();
  const [module, setModule] = useState(null);

  const handleBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    setModule({
      id: moduleId,
      title: "Fall Prevention and Safety",
      description: "Comprehensive guide to fall prevention strategies and monitoring in elderly care settings."
    });
  }, [moduleId]);

  if (!module) {
    return (
      <Box sx={{ width: '100%', p: 3 }}>
        <LinearProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ p: 2 }}>
        <IconButton
          onClick={handleBack}
          sx={{ mr: 2 }}
          aria-label="back"
        >
          <ArrowBackIcon />
        </IconButton>
      </Box>
      <ModuleLayout />
    </Box>
  );
}

export default ModulePage;
